<template>
	<div class="container">
		<loading-spinner v-if="isLoading"></loading-spinner>
		<alert-message
			v-if="!isLoading && errorMessage"
			class="large-panel"
		></alert-message>
		<div
			class="container-fluid category-panel large-panel"
			v-if="!isLoading && appData && appData.categories"
		>
     <home-page />
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner";
import AlertMessage from "./AlertMessage";
import CategoriesModal from "./CategoriesModal";
import CategoryMixin from "../mixins/CategoryMixin";
import AppMixin from "../mixins/AppMixin";
import VueLazyload from "vue-lazyload";
import placeHolderImage from "@/assets/images/placeholder.png";
import Vue from "vue";
import HomePage from "@/components/homepage/HomePage";

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: placeHolderImage,
	attempt: 1,
	loading: placeHolderImage,
});
export default {
	name: "root-categories",
	data() {
		return {
			showSpinner: false,
			errorOccurred: false,
			showError: false,
			appData: null,
		};
	},

	created() {
		window.scrollTo(0, 0);
		this.initializeComponent();
	},
	mixins: [CategoryMixin, AppMixin],
	watch: {
		currentUser() {
			this.setCurrentAppData(null);
			this.initializeComponent();
		},
	},
  mounted() {
    if (this.appData && this.appData.categories){
      this.initializeTooltip()
    }
  },
	computed: {
		...mapGetters([
			"authToken",
			"isLoading",
			"currentUser",
			"errorMessage",
			"breadcrumbItems",
			"currentAlias",
			"currentAppData",
			"searchKeyword",
			"historyArray",
		]),
		sortCategoryByName() {
			return this.sortCategories(this.appData.categories);
		},
	},
	methods: {
		...mapActions(["getAppData"]),
		...mapMutations([
			"setErrorMessage",
			"setIsLoading",
			"setCurrentAlias",
			"setCurrentAppData",
			"setAllCategories",
			"setBreadcrumbItems",
			"setCurrentCategory",
			"setCurrentSubCategory",
			"setHistoryArray",
		]),
    initializeTooltip() {
      /* eslint-disable no-undef */
      Vue.nextTick(function() {
        if (!window.matchMedia || (window.matchMedia("(min-width: 991px)").matches)) {
          $('[data-toggle="tooltip"]').tooltip();
        }

      });
    },
		onCategoryClicked(category, event) {
			if (event) event.preventDefault();

			this.setCurrentCategory(category);
			let breadcrumbItems = [];
			breadcrumbItems.push(category);
			this.setBreadcrumbItems(breadcrumbItems);
			this.trackEvent(category);
			category.categoryMetaData.childrenPageType &&
			category.categoryMetaData.childrenPageType === "FULL_PAGE"
				? this.openFullPageCategories(category)
				: this.openModalCategories(category);
		},
		openModalCategories(category) {
			this.$modal.show(
				CategoriesModal,
				{ category: category },
				{
					adaptive: true,
					maxWidth: 800,
					height: "600",
					classes: ["app-modal"],
					width: "100%",
				}
			);
		},
		openFullPageCategories(category) {
			this.setCurrentSubCategory(category);
			this.navigateToChildCat(category);
		},
		navigateToChildCat(category) {
			this.setHistoryArray([...this.historyArray, category]);
			this.$router.push("/" + this.$route.params.alias + "/" + category.id);
		},
		initializeComponent() {
			if (!this.currentAlias) this.setCurrentAlias(this.$route.params.alias);
			if (!this.currentAppData) {
				this.getAppData(this.currentAlias).then(() => {
					this.appData = this.currentAppData;
					this.processAppDataResponse(this.currentAppData);
				}).finally(()=>{
          this.initializeTooltip()
        });
			} else {
				this.appData = this.currentAppData;
			}
		},
	},
	components: {
    HomePage,
		AlertMessage,
		LoadingSpinner,
	},
};
</script>

<style scoped>
.category-title {
	color: #000000;
	font-family: artifaktElementBold;
	font-size: 16px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
}
.large-panel {
	padding-right: 35px;
}
.category-container {
	min-height: 120px;
	margin-bottom: 30px;
	max-height: 280px;
	border-radius: 3px;
	border: 1px solid #b0b9c3;
	cursor: pointer;
}

.info-container {
	padding: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	max-height: 80px;
	min-height: 80px;
	height: 100%;
}
.cat-image-card img {
	width: 100%;
	height: 200px;
	object-fit: cover;
}
.cat-icon-card {
	height: 200px;
	text-align: center;
	background: #f0faff;
	display: flex;
}
.cat-icon-card img {
	background: #f0faff;
	width: 100%;
	padding-right: 1em;
	padding-left: 1em;
	height: 130px;
}
</style>
